import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrWrapperTwoColumnsModule } from '@toro/common/shared/components/tr-wrapper-two-columns/tr-wrapper-left-column.module';
import { TrSpinnerButtonDirectiveModule } from '@toro/common/shared/directives';
import { ModalModule } from '@toro/common/shared/components/modal/modal.module';
import { ModalWelcomePiComponent } from './modal-welcome-pi.component';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
        TrWrapperTwoColumnsModule,
        TrSpinnerButtonDirectiveModule,
    ],
    exports: [ModalWelcomePiComponent],
    declarations: [ModalWelcomePiComponent],
})
export class ModalWelcomePiModule { }
